import PropTypes from 'prop-types';
import useStyles from './LabelWrapper.styles';

function LabelWrapper(props) {
  const classes = useStyles();
  
  return (
    <div className={classes.labelWrap}>
      {props.children}
    </div>
  );
}

LabelWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LabelWrapper;
